import { withTranslation } from "react-i18next";

import FlightDetail from './FlightDetail';

export default withTranslation()(FlightDetail);